import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { CredentialedScanningType, type CredTypeOptions } from '../../../types';

export const useCredTypeOptions = (): CredTypeOptions[] => {
  const { t } = useTranslation('telemetryScannerConfig');
  return useMemo(
    () => [
      {
        text: t('credentialedScanningForm.typeOption.usernameOrPass'),
        value: CredentialedScanningType.Up,
      },
      {
        text: t('credentialedScanningForm.typeOption.usernameSSHKey'),
        value: CredentialedScanningType.Usk,
      },
    ],
    [t],
  );
};
